<template>
  <!-- Price Section start-->
  
<div class="taption-terms" name="termly-embed" data-id="64d082f9-4de8-42f5-8dee-84328191e63f" data-type="iframe"></div>

</template>

<script>

export default {
    name: 'TermsPage',
    created(){
        const id = 'termly-jssdk';
        var js, tjs = document.getElementsByTagName('script')[0];
        if (document.getElementById(id)) return;
        js = document.createElement('script'); 
        js.id = id;
        js.src = "https://app.termly.io/embed-policy.min.js";
        
        tjs.parentNode.insertBefore(js, tjs);
    }
}
</script>

<style scoped>
.taption-privacy{
    padding:0px 100px;
}
</style>